/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'equiptype': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M516.8 441.3h324.6c11.3 0 20.5 9.2 20.5 20.5s-9.2 20.5-20.5 20.5H516.8c-11.3 0-20.5-9.2-20.5-20.5s9.2-20.5 20.5-20.5zm0 163.8h324.6c11.3 0 20.5 9.2 20.5 20.5s-9.2 20.5-20.5 20.5H516.8c-11.3 0-20.5-9.2-20.5-20.5 0-11.4 9.2-20.5 20.5-20.5zm0 163.7h324.6c11.3 0 20.5 9.2 20.5 20.5s-9.2 20.5-20.5 20.5H516.8c-11.3 0-20.5-9.2-20.5-20.5s9.2-20.5 20.5-20.5zM411.3 504.3H206.6c-12.2 0-22-9.9-22-22V277.6c0-12.1 9.8-22 22-22h204.7c12.2 0 22 9.9 22 22v204.6c0 12.2-9.8 22.1-22 22.1zm-182.7-44h160.7V299.6H228.6v160.7zm182.7 371.4H206.6c-12.2 0-22-9.9-22-22V605.1c0-12.1 9.8-22 22-22h204.7c12.2 0 22 9.9 22 22v204.7c0 12.1-9.8 21.9-22 21.9zm-182.7-44h160.7V627.1H228.6v160.6zM516.8 277.6h324.6c11.3 0 20.5 9.2 20.5 20.5s-9.2 20.5-20.5 20.5H516.8c-11.3 0-20.5-9.2-20.5-20.5s9.2-20.5 20.5-20.5z"/>'
  }
})
